<template>
  <div id="modalPagamento" class="modal-pagamento" v-show="opened">
    <div class="modal-pagamento-content modal-rounded-scroll">
      <top-bar :title="modalTroco ? 'Troco pra quanto?' : 'Pagamentos'" event="true" :fixo="false" @voltar="closeModal"/>
      <div class="container mt-3 mb-4">
        <div v-if="!modalTroco">
          <aviso-informativo variante="amarelo" class="mb-3" v-if="apenasOnline && !pagOnline.length">
            No momento não há formas de pagamento online disponíveis.
          </aviso-informativo>
          <div v-if="pagOnline.length && pagEntrega.length">
            <modal-menu :menus="menus" :selected="menu" @changeMenu="(m) => this.menu = m" class="mb-3"/>
          </div>
          <div id="pagEntrega" v-if="pagEntrega.length && menu !== 2">
            <div style="margin: 22px 0 14px">Pagar na Entrega</div>
            <a class="text-dark" href="javascript:" v-for="p in pagEntrega" @click="selecionar(p)">
              <div class="card card-pagamento bg-white mb-3" :class="{'border-primary': dados.id_pagamento === p.id_pagamento}">
                <div class="card-body d-flex align-items-center">
                  <div class="card-pagamento-icone" v-if="p.img_pagamento">
                    <img :src="p.img_pagamento" alt="Imagem pagamento">
                  </div>
                  <div class="card-pagamento-texto">
                    <h6 class="m-0">{{p.nome_pagamento}}</h6>
                    <div v-if="total > 0">
                      <p class="small mb-0" v-if="p.tipo_desconto > 0 && p.valor_taxa !== '0.0'">
                        <span v-if="p.tipo_desconto === '1'">
                          {{ p.valor_taxa * -1 }}% {{ p.minimo_desconto > 0 ? ' off acima de R$ ' + p.minimo_desconto : ' de desconto' }}
                        </span>
                        <span v-if="p.tipo_desconto === '2'">{{ calcularValor(p) | valor }} de taxa ({{p.valor_taxa}}%)</span>
                      </p>
                    </div>
                  </div>
                  <div class="text-right" style="margin-left: auto">
                    <indicador-selecao :selecionado="dados.id_pagamento === p.id_pagamento"/>
                  </div>
                </div>
              </div>
            </a>
          </div>
          <div id="pagOnline" v-if="pagOnline.length">
            <div style="margin: 26px 0 14px" v-show="menu !== 2">Pagar pelo App</div>
            <a class="text-dark" href="javascript:" v-for="p in pagOnline" @click="selecionar(p)">
              <div class="card card-pagamento bg-white mb-3" :class="{'border-primary': dados.id_pagamento === p.id_pagamento}">
                <div class="card-body d-flex align-items-center">
                  <div class="card-pagamento-icone">
                    <img :src="p.img_pagamento" alt="Imagem pagamento">
                  </div>
                  <div class="card-pagamento-texto">
                    <h6 class="m-0 d-flex align-items-center flex-wrap">
                      <span>{{p.nome_pagamento}}</span>
                      <span v-if="isPix(p)" class="tag-pedido-rapido">PEDIDO MAIS RÁPIDO</span>
                    </h6>
                    <div v-if="total > 0">
                      <p class="small mb-0" v-if="p.tipo_desconto > 0 && p.valor_taxa !== '0.0'">
                      <span v-if="p.tipo_desconto === '1'">
                        {{ p.valor_taxa * -1 }}% {{ p.minimo_desconto > 0 ? ' off acima de R$ ' + p.minimo_desconto : ' de desconto' }}
                      </span>
                        <span v-if="p.tipo_desconto === '2'">{{ calcularValor(p) | valor }} de taxa ({{p.valor_taxa}}%)</span>
                      </p>
                    </div>
                  </div>
                  <div class="text-right" style="margin-left: auto">
                    <indicador-selecao :selecionado="dados.id_pagamento === p.id_pagamento"/>
                  </div>
                </div>
              </div>
            </a>
          </div>
        </div>
        <div v-else>
          <div class="card card-border bg-light mb-3">
            <div class="card-body d-flex align-items-center">
              <div class="mr-1">
                <img :src="dados.img_pagamento" alt="Imagem pagamento" class="mr-2" style="width: 24px">
              </div>
              <div>
                <h6 class="font-weight-bold mb-0">Dinheiro <a href="javascript:" class="text-primary" @click="modalTroco = false">(alterar)</a></h6>
                <div>
                  Valor do pedido: <b>{{(total + calcularValor(dados)) | valor}}</b>
                </div>
                <div>
                  Valor do troco: <b v-if="dados.troco > total">{{dados.troco - (total + calcularValor(dados)) | valor}}</b><small v-else>(Informe o valor)</small>
                </div>
              </div>
            </div>
          </div>
          <form @submit.prevent="addPagamento">
            <label class="small mb-0 font-weight-bold">Digite o valor que vai pagar em dinheiro</label>
            <money class="form-control" id="trocoPedido" v-model="dados.troco"/>
            <div class="my-2">
              <button class="btn btn-primary btn-block font-weight-bold" :disabled="!dados.troco">Salvar</button>
            </div>
            <div>
              <button type="button" class="btn btn-block" @click="semTroco()">
                <span class="font-weight-bold text-primary">Não preciso de troco</span>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AvisoInformativo from "./AvisoInformativo";
  import CardInfo from './CardInfo'
  import TopBar from "./TopBar";
  import Loading from "./Loading";
  import Icon from "./Icon";
  import ModalMenu from "./ModalMenu";
  import IndicadorSelecao from "./IndicadorSelecao";

  export default {
    name: "FormasPagamento",
    components: {AvisoInformativo, IndicadorSelecao, ModalMenu, Icon, Loading, TopBar, CardInfo},
    props: ['sacola', 'apenasOnline'],
    data() {
      return {
        token: localStorage.getItem('token'),
        opened: false,
        total: 0,
        dados: {
          valor_taxa: 0,
          id_pagamento: '',
          tipo_desconto: '0',
          minimo_desconto: 0,
          img_pagamento: 0,
          troco: 0
        },
        menu: 1,
        modalTroco: false,
        finalizar: false,
        menus: [
          { nome: 'Pagar na Entrega', active: false },
          { nome: 'Pagar pelo App', active: false }
        ],

        pagamentos: [],
        pagOnline: [],
        pagEntrega: [],
      }
    },

    methods: {
      closeModal() {
        document.body.classList.remove("modal-open");
        this.opened = false;
      },

      selecionar(p) {
        this.dados.id_pagamento = p.id_pagamento;
        this.dados.valor_taxa = p.valor_taxa || 0;
        this.dados.minimo_desconto = p.minimo_desconto || 0;
        this.dados.tipo_desconto = p.tipo_desconto || '0';
        this.dados.img_pagamento = p.img_pagamento || null;

        if (p.id_pagamento === '1') {
          this.dados.troco = 0;
          this.$swal({
            text: 'Vai precisar de troco?',
            buttons: ["Não", "Sim"],
            dangerMode: true
          }).then((r) => {
            if (r) {
              this.menu = 1;
              this.modalTroco = true;
              this.$nextTick(() => {
                this.$helpers.focusrElement('trocoPedido');
              });

            } else {
              this.addPagamento();
            }
          });

        } else {
          this.dados.troco = '';
          this.addPagamento();
        }
      },

      addPagamento() {
        if (this.dados.troco > 0) {
          if (this.total > this.dados.troco) {
            this.$swal('Por favor informe o valor que vai pagar em dinheiro. O valor informado deve ser maior que o valor do pedido.').then(() => {
              this.$helpers.focusrElement('trocoPedido');
            });
            return;
          }

          if (this.dados.troco > 10000) {
            this.$swal('Por favor informe um valor válido para o troco.').then(() => {
              this.$helpers.focusrElement('trocoPedido');
            });
            return;
          }
        }

        this.closeModal();
        this.$emit('addPagamento', this.dados, this.finalizar);
      },

      semTroco() {
        this.dados.troco = 0;
        this.addPagamento();
      },

      calcularValor(pag) {
        if (pag.tipo_desconto === '2' || (pag.tipo_desconto === '1' && this.total >= pag.minimo_desconto)) {
          return parseFloat((this.total * (pag.valor_taxa / 100)).toFixed(2));
        }

        return 0;
      },

      isPix(pagamento) {
        return (pagamento.nome_pagamento || '').toLowerCase().includes('pix');
      },

      abrirPagamento() {
        document.body.classList.add("modal-open");
        this.opened = true;
        this.dados.id_pagamento = this.sacola.id_pagamento;
        this.dados.troco = this.sacola.troco;
        this.dados.valor_taxa = this.sacola.pagamento ? (this.sacola.pagamento.valor_taxa || 0) : 0;
        this.dados.minimo_desconto = this.sacola.pagamento ? (this.sacola.pagamento.minimo_desconto || 0) : 0;
        this.dados.tipo_desconto = this.sacola.pagamento ? (this.sacola.pagamento.tipo_desconto || '0') : '0';
        this.dados.img_pagamento = this.sacola.pagamento ? (this.sacola.pagamento.img_pagamento || null) : null;
        this.total = this.sacola.total - this.sacola.valor_taxa;
        const pagamentos = this.empresa.pagamentos;

        if (!pagamentos || !pagamentos.length) {
          return;
        }

        this.pagOnline = this.empresa.pagamentos.filter(p => p.categoria === '5');
        this.pagEntrega = [];

        if (!this.apenasOnline) {
          this.pagEntrega = this.empresa.pagamentos.filter(p => p.categoria !== '5');
        }

        if (this.pagOnline.length && this.pagEntrega.length) {
          this.menus[0].active = true;
          this.menus[1].active = true;
        }

        this.$nextTick(() => {
          if (this.modalTroco) {
            this.dados.troco = 0;
            this.$helpers.focusrElement('trocoPedido');
          }
        })
      }
    },

    created() {
      this.$parent.$on('openModalPagamento', (troco, finalizar) => {
        this.modalTroco = !!troco;
        this.finalizar = !!finalizar;
        this.abrirPagamento();
      });
    },

    computed: {
      empresa() {
        return this.$store.state.empresa
      }
    },
  }
</script>

<style scoped>
  .modal-pagamento {
    display: block;
    position: fixed; /* Stay in place */
    z-index: 1040; /* Sit on top */
    left: 0;
    top: 0;
    width: 100%; /* Full width */
    height: 100%; /* Full height */
    background-color: rgb(0, 0, 0); /* Fallback color */
    background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */
  }

  .modal-pagamento-content {
    background-color: #fefefe;
    overflow: auto;
    margin: 48px auto;
    width: 500px;
    height: 75vh;
    position: relative;
    border-radius: 12px;
  }

  .card-pagamento .card-body {
    min-height: 82px;
    padding: 16px 18px;
  }

  .card-pagamento {
    border: 1px solid #e3e6e9;
    box-shadow: none;
  }

  .card-pagamento-icone {
    display: flex;
    flex: 0 0 22px;
    align-items: center;
    justify-content: center;
    margin-right: 9px;
  }

  .card-pagamento-icone img {
    display: block;
    max-width: 22px;
    max-height: 22px;
  }

  .card-pagamento-texto {
    display: flex;
    min-width: 0;
    flex: 1;
    flex-direction: column;
    justify-content: center;
  }

  .card-pagamento-texto h6 {
    font-size: 14px;
    line-height: 1.25;
  }

  .card-pagamento-texto .small {
    font-size: 12px;
    line-height: 1.35;
  }

  .tag-pedido-rapido {
    background-color: rgba(0, 150, 136, 0.08);
    border: 1px solid rgba(0, 150, 136, 0.18);
    border-radius: 5px;
    color: #008c82;
    font-size: 11px;
    font-weight: 600;
    letter-spacing: .2px;
    margin-left: 10px;
    padding: 4px 7px;
    white-space: nowrap;
  }

  @media (max-width: 600px) {
    .modal-pagamento-content {
      overflow: auto;
      min-height: 100%;
      height: 100vh;
      width: 100%;
      margin: 0;
      border-radius: 0;
      clip-path: none;
    }
  }
</style>
